import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Wrapper = styled.div`
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;

    li {
      a {
        display: block;
        padding: 10px 15px;
        text-decoration: none;
        color: ${props => props.theme.palette.general.strong};
        background: ${props => props.theme.palette.general.soft};
        border: 1px solid ${props => props.theme.palette.general.greyMed};

        &.active {
          background: ${props => props.theme.palette.general.light};
          border-bottom: 0;
        }
      }

      &:not(:last-child) {
        a {
          border-width: 1px 0 1px 1px;
        }
      }
    }
  }
`

export const Heading = styled.div`
  margin: 10px 0 15px;

  > div {
    margin: 10px 0;

    a {
      color: ${props => props.theme.palette.primary.alphaDark};
      font: ${font('default', 'bold', '16px/1.5')};
    }
  }

  h1 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .status {
    font: ${font('default', 'normal', '14px/1.5')};
    text-transform: uppercase;
    display: inline-block;
    padding: 2px 10px;
    border: 1px solid ${props => props.theme.palette.general.grey};
    border-radius: 4px;
    color: ${props => props.theme.palette.general.greyDark};
    margin: 10px 0 0 20px;
  }
`
